<template lang='pug' src='./Home.pug'></template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Filters from '../../components/Filters/Filters'
  import Navbar from '../../components/Navbar/Navbar'
  import QuotesList from '../../components/QuotesList/QuotesList'
  import AddQuotes from '../../components/AddQuotes/AddQuotes'

  import { noAuth } from '../../lib/errors'
  import me from '../../vuex/store'

  export default {
    name: 'Home',
    components: {
      Navbar,
      QuotesList,
      AddQuotes,
      Filters
    },
    computed: {
      ...mapGetters([
        'getChangeQuotes'
      ])
    },
    methods: {
      ...mapActions([
        'me',
        'filterQuotes',
        'kaleiders'
      ])
    },
    created () {
      return this.filterQuotes()
        .then(() => this.kaleiders())
        .catch(() => noAuth())
    },
    beforeRouteEnter (to, from, next) {
      return me.dispatch('me')
        .then(next)
        .catch(noAuth)
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?123b78f2